import api from '../../plugins/api';

const createComplectation = (params) => {
  return api.post('/api/crm/cars/createComplectation', params);
};

export default createComplectation;
